<template>
  <div class="app12">
    <div class="container12">
      <div class="selType">请选择随手拍类型</div>
      <ul class="typeList">
        <li v-for="(item, index) in typeList" :key="index" class="active">
          <div class="word">{{ item }}</div>
        </li>
      </ul>
      <div class="contentArea">
        <textarea
          id="a"
          v-model="text"
          maxlength="200"
          @input="limitLength"
          placeholder="请在这里写下这一刻您的想法/或者您的关注焦点等个性内容..."
        ></textarea>

        <div class="dibuTongji">
          <div
            class="fabuAddr"
            @click="goSelAddr"
            v-show="typeof address == 'undefined' || where"
          >
            <img src="../assets/images/dingwei.svg" alt="" />
            <div class="word">你在哪里？</div>
          </div>
          <div
            class="fabuAddr successAddr"
            v-show="!address == '' && afterAddr"
            @click="goSelAddr"
          >
            <img src="../assets/images/dingwei.svg" alt="" />
            <div class="word">{{ address }}</div>
          </div>

          <div class="wordLimit">{{ areaLength }}/200</div>
        </div>
      </div>
      <div class="sendPic">
        <van-uploader
          :after-read="afterRead"
          v-model="fileList"
          :max-count="6"
          @delete="delImg"
        />
      </div>
      <div class="dibubtn">
        <van-button type="primary" size="large" @click="saveInfor"
          >发布</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import Vue from "vue";
import { Field } from "vant";
import { Uploader } from "vant";
import { Dialog } from "vant";
import { Toast } from "vant";
Vue.use(Toast);
import qs from "qs";

Vue.use(Uploader);
Vue.use(Field);
export default {
 beforeRouteLeave: (to, from, next) => {
   console.log(to.query);
   console.log(from.query);
   next()
 },
  mounted() {

    this.address = this.$route.query.address;
    this.lat = this.$route.query.lat;
    this.lng = this.$route.query.lng;
    this.afterAddr = this.$route.query.afterAddr;
    this.text = this.$route.query.content;

    if (this.text == "" || typeof this.$route.query.content == "undefined") {
      this.areaLength = "0";
    } else {
      this.limitLength();
    }
    if (typeof this.$route.query.fileurlList == "undefined") {
      return;
    } else {
      this.fileurlList = this.$route.query.fileurlList;
    }
    if (typeof this.$route.query.fileList == "undefined") {
      return;
    } else {
      this.fileList = this.$route.query.fileList;
    }
  },
  data() {
    return {
      typeList: ["失物招领"],
      message: "",
      isBlueShow: true,
      isWhiteShow: false,
      text: "",
      areaLength: "0",
      fileList: [],
      fileurlList: [],
      file: [],
      address: "",
      lng: "",
      lat: "",
      where: false,
      afterAddr: false,
      file1: null,
      fabuType: 2,
    };
  },
  methods: {
    goSelAddr() {
      this.afterAddr = true;
      this.where = false;
      this.$router.push({
        name: "Map1",
        query: {
          content: this.text,
          fileurlList: this.fileurlList,
          fileList: this.fileList,
        },
      });
    },
    delImg(file, detail) {
      console.log(this.fileurlList);

      let params = qs.stringify({
        picturePath: this.fileurlList[detail.index],
      });
      console.log(this.fileurlList[detail.index]);
      this.$axios
        .post("appinteraction/appInteraction/delImg", params)
        .then((res) => {
          console.log(this.fileurlList);
          console.log(res);
          if (res.data.result !== 1) {
            this.$toast("删除失败");
          }
          if (res.data.result === 1) {
            this.fileurlList.splice(detail.index, 1);
            this.$toast("删除成功");
            console.log(this.fileurlList);
            console.log(res);
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    limitLength() {
      if (typeof this.text !== "undefined") {
        this.areaLength = this.text.length;
      }
    },

    async afterRead(file, detail) {
      let f = file.file;
      console.log(f);
      if (f.size > 10485760) {
        Dialog.alert({
          message: "图片大小超过10M，请选择10M以内图片上传",
        }).then(() => {
          this.fileList.splice(detail.index, 1);
        });
        return;
      }
      if (f.type == "image/gif") {
        Dialog.alert({
          message: "不支持GIF类型图片，请选择正确类型的图片上传",
        }).then(() => {
          this.fileList.splice(detail.index, 1);
        });
        return;
      }
      let formdata = new FormData();

      console.log(f);
      formdata.append("fileList", f);

      Toast.loading({
        message: "图片上传中...",
        forbidClick: true,
      });
      this.$axios
        .post("/appinteraction/appInteraction/uploadImg", formdata, {
          headers: {
            "Content-Type":
              "multipart/form-data; boundary = " + new Date().getTime(),
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
              Toast.clear()
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            this.fileurlList.push(res.data.fileurlList[0]);
            console.log(this.fileurlList);
            Toast.success("图片上传成功");
          }
        })
        .catch((err) => {
            Toast.clear()
          console.log(err);
          alert(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
        });
    },

    goHudong() {
      this.$router.push("/");
    },

    saveInfor() {
      if (this.text == "") {
        Dialog.alert({
          message: "填写内容不能为空",
        }).then(() => {});
        return;
      }
      if (this.fileList.length == 0) {
        Dialog.alert({
          message: "上传图片不能为空",
        }).then(() => {});
        return;
      }
      let parameter = {
        fileurlList: this.fileurlList.join(","),
        type: 2,
        content: this.text,
        position: this.address,
        lng: this.lng,
        lat: this.lat,
      };

      this.$axios
        .post(
          "appinteraction/user/appInteraction/saveAppInteraction",
          parameter
        )
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            console.log(res);
            Dialog.alert({
              title: "提示",
              message: res.data.reason,
            }).then(() => {
              this.$router.push({ name: "Hudong", query: {} });
            });
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/Fabu.scss";
</style>
<style lang="scss" scoped>
.sendPic ::v-deep .van-uploader .van-uploader__upload {
  width: 12.75rem;
  height: 12.75rem;
  margin: 0;
  background-color: #fff;
  border: 1px dashed #eaeaea;
  border-radius: 1rem;
  background-image: url("../assets/images/shizijia.png");
  background-repeat: no-repeat;
  background-size: 4rem 4rem;
  background-position: 50% 50%;
  .van-icon {
    display: none;
  }
}
.sendPic ::v-deep .van-uploader .van-uploader__preview {
  margin: 0 1.5rem 1.5rem 0;
  .van-uploader__preview-image {
    width: 12.75rem;
    height: 12.75rem;
    img {
      width: 12.75rem;
      height: 12.75rem;
      border-radius: 1rem;
    }
  }
}
</style>
